export default __webpack_public_path__ + "static/media/ghost.6cc8b706.png";